import clsx from "clsx";

import {
  type ChannelInsightsSortDirection,
  useModelInsightsSorting,
  type ChannelInsightsSortType,
  useModelInsightsKPI,
} from "@features/mmm/hooks/mmm-url-state";
import { ModelInsightsTrackedComponent } from "@pages/mmm/amplitude-tracking/components";
import {
  getMMMEventSelectionData,
  MMMTab,
} from "@pages/mmm/amplitude-tracking/mmm-event";
import { useTrackMMMEvent } from "@pages/mmm/amplitude-tracking/use-track-mmm-event";
import { FlatSelect } from "@shared/flat-select";
import { Select } from "@shared/selects";

import { KpiType } from "../../explore-budgets/client-setting/types";

export const ChannelSortSelect = ({ className }: { className?: string }) => {
  const [sorting, setSorting] = useModelInsightsSorting();
  const trackMMMEvent = useTrackMMMEvent(MMMTab.MODEL_INSIGHTS);
  const [selectedKpi] = useModelInsightsKPI();

  return (
    <div className={clsx(className, "space-x-2")}>
      <Select
        width="200px"
        label="SORT"
        value={sorting.column}
        options={[
          { label: "Spend", value: "spend" },
          {
            label: selectedKpi?.friendly_name || "KPI",
            value: "kpi",
          },
          {
            label: selectedKpi?.kpi_type === KpiType.REVENUE ? "ROAS" : "CAC",
            value: "efficiency",
          },
          { label: "Name", value: "column_name" },
        ]}
        onChange={(value: ChannelInsightsSortType) => {
          trackMMMEvent({
            component:
              ModelInsightsTrackedComponent.CHANNEL_INSIGHTS_SORT_BY_SELECTOR,
            action: "onChange",
            actionInfo: "Change channel insights sort order",
            data: getMMMEventSelectionData(value),
          });
          setSorting({ ...sorting, column: value });
        }}
      />
      <div className="flex items-end">
        <FlatSelect
          optionClassName="min-w-[46px]"
          options={[
            { label: "ASC", value: "asc" as ChannelInsightsSortDirection },
            { label: "DESC", value: "desc" as ChannelInsightsSortDirection },
          ]}
          setSelected={({ value }) => {
            setSorting({ ...sorting, direction: value });
          }}
          selected={{ value: sorting.direction, label: sorting.direction }}
        />
      </div>
    </div>
  );
};
